import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { ADULTS, CHILDREN } from 'components/NumberOfGuests/constants';
import { SelectedPills } from 'components/SelectedPills/SelectedPills';
import { BasicButton } from 'components/buttons/BasicButton/BasicButton';
import { useAppContext } from 'contexts/appContext';
import { breakPhraseInTwo } from 'lib/utils/breakPhraseInTwo';
import { useCallback, useMemo } from 'react';
import styles from './Footer.css';

const Footer = () => {
	const { clearSelection, clearApplied, setActiveFilter, historicalSelection, updateApplied, removeHistoricalSelectionPill } = useFiltersContext();
	const { setShowFiltersModal, updateNumberOfGuestsApplied, clearNumberOfGuestsApplied } = useFiltersModalContext();

	const { dictionary } = useAppContext();
	const { actionModalResetAll: resetAllLabel, actionModalApply: applyLabel, labelAllFiltersSelected } = dictionary;

	const handleApplyClick = useCallback(() => {
		setShowFiltersModal(false);
		setActiveFilter(null);
		updateApplied(null, null, true);
		updateNumberOfGuestsApplied();
	}, [setActiveFilter, setShowFiltersModal, updateApplied, updateNumberOfGuestsApplied]);

	const filterHistoricalSelection = useMemo(() => {
		return historicalSelection.filter((option) => option.filterKey !== ADULTS && option.filterKey !== CHILDREN);
	}, [historicalSelection]);

	const renderLabel = useCallback(() => {
		const lines = breakPhraseInTwo(labelAllFiltersSelected);
		return (
			<>
				{lines.map((line, index) => (
					<>
						{line}
						{index < lines.length - 1 && <br />}
					</>
				))}
			</>
		);
	}, [labelAllFiltersSelected]);

	return (
		<div className={styles.root}>
			{filterHistoricalSelection.length > 0 && (
				<span className={styles.selection}>
					<span data-testid="filters-selected-filters-label" className={styles.label}>
						{renderLabel()}
					</span>
					<SelectedPills
						selection={filterHistoricalSelection}
						optionTestId="option-{{label}}-test-id"
						onOptionCrossClick={(option) => removeHistoricalSelectionPill(option, false)}
					/>
				</span>
			)}
			<span className={styles.buttonsContainer}>
				<BasicButton
					testId="clear-all-selected-filters-button"
					label={resetAllLabel}
					variant={'outlined'}
					onClick={() => {
						clearSelection();
						clearApplied();
						clearNumberOfGuestsApplied();
					}}
					customClass={styles.button}
				/>
				<BasicButton
					testId="search-all-selected-filters-button"
					label={applyLabel}
					variant={'fullColor'}
					onClick={handleApplyClick}
					customClass={styles.button}
				/>
			</span>
		</div>
	);
};

export { Footer };
